import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Chip,
  Divider,
  Button,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import CampaignIcon from "@mui/icons-material/Campaign";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

// Updated Gradient to match the screenshot
const HEADER_BG_COLOR = "#1e3a8a"; // Dark blue color
const VIEW_BUTTON_BG_COLOR = "#0f4c75"; // Dark teal color

const ParentsAnnouncement = () => {
  const navigate = useNavigate();

  const [announcements, setAnnouncements] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [search, setSearch] = useState("");
  const API_URL = process.env.REACT_APP_BASE_URL;
  const parentName = sessionStorage.getItem("clientName");

  const fetchAnnouncements = async () => {
    setLoading(true);
    try {
      const authToken = sessionStorage.getItem("token") || "YOUR_AUTH_TOKEN";
      const response = await fetch(`${API_URL}/Anouncement/Parents_Anouncement`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken,
        },
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch announcements: ${response.status}`);
      }
      const data = await response.json();
      const sorted = data.list.sort((a, b) => {
        const [d1, m1, y1] = a.createdOn.split("/");
        const [d2, m2, y2] = b.createdOn.split("/");
        return new Date(`${y2}-${m2}-${d2}`) - new Date(`${y1}-${m1}-${d1}`);
      });
      setAnnouncements(sorted);
      setFilteredData(sorted);
    } catch (error) {
      console.error("Error fetching announcements:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  useEffect(() => {
    const result = announcements.filter((item) =>
      item.title.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredData(result);
    setPage(0);
  }, [search, announcements]);

  const formatDate = (dateStr) => {
    const [day, month, year] = dateStr.split("/");
    return new Date(`${year}-${month}-${day}`).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const handleViewMessage = (msg) => {
    setMessage(msg);
    setOpen(true);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 6 }}>
      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Box display="flex" alignItems="center" gap={1}>
          <CampaignIcon sx={{ color: "#dc2626" }} fontSize="large" />
          <Typography variant="h4" fontWeight="bold" sx={{ color: "#dc2626" }}>
            Announcements for Parents
          </Typography>
        </Box>
        
      </Box>

     

      {/* SEARCH BAR */}
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <TextField
          placeholder="Search by Title..."
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{
            width: 280,
            "& .MuiOutlinedInput-root": {
              borderRadius: "30px",
            },
          }}
        />
      </Box>

      {loading ? (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Paper elevation={6} sx={{ borderRadius: 2, overflow: "hidden" }}>
          <TableContainer>
            <Table>
              <TableHead sx={{ background: 'linear-gradient(110deg, rgba(75,108,183,1) 11.3%, rgba(24,40,72,1) 99.3%)' }}>
                <TableRow>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Title</TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold", width: 140 }}>Message</TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Posted By</TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.length > 0 ? (
                  filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((item, index) => (
                      <React.Fragment key={item.noticeBoardId}>
                        <TableRow hover>
                          <TableCell>
                            <Typography fontWeight="bold">{item.title}</Typography>
                          </TableCell>
                          <TableCell>
                            <Button
                              size="small"
                              variant="contained"
                              onClick={() => handleViewMessage(item.message)}
                             sx={{
  textTransform: "none",
  borderRadius: 2,
  background: "linear-gradient(110deg, rgba(75,108,183,1) 11.3%, rgba(24,40,72,1) 99.3%)",
  "&:hover": {
    background: "linear-gradient(110deg, rgba(75,108,183,1) 11.3%, rgba(24,40,72,1) 99.3%)",
  },
}}

                            >
                              View
                            </Button>
                          </TableCell>
                          <TableCell>
                            <Chip label={item.createdBy} size="small" variant="outlined" />
                          </TableCell>
                          <TableCell>{formatDate(item.createdOn)}</TableCell>
                        </TableRow>
                        {index <
                          filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .length - 1 && (
                            <TableRow>
                              <TableCell colSpan={4} sx={{ p: 0 }}>
                                <Divider />
                              </TableCell>
                            </TableRow>
                          )}
                      </React.Fragment>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center" py={4}>
                      No announcements available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(e, newPage) => setPage(newPage)}
            onRowsPerPageChange={(e) => {
              setRowsPerPage(parseInt(e.target.value, 10));
              setPage(0);
            }}
          />
        </Paper>
      )}

      {/* MESSAGE DIALOG */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 700 }}>Message</DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            sx={{
              p: 2,
              border: "1px solid #e0e0e0",
              backgroundColor: "#fafafa",
              borderRadius: 2,
            }}
            dangerouslySetInnerHTML={{ __html: message }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
           sx={{
  textTransform: "none",
  borderRadius: 2,
  background: "linear-gradient(110deg, rgba(75,108,183,1) 11.3%, rgba(24,40,72,1) 99.3%)",
  "&:hover": {
    background: "linear-gradient(110deg, rgba(75,108,183,1) 11.3%, rgba(24,40,72,1) 99.3%)",
  },
}}

            onClick={() => setOpen(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default ParentsAnnouncement;
